export default {
  SET_BUSINESS_RULES: 'businessRules/SET_BUSINESS_RULES',
};
